import { render, staticRenderFns } from "./logisticsPark.vue?vue&type=template&id=6033228d&scoped=true"
import script from "./logisticsPark.vue?vue&type=script&lang=js"
export * from "./logisticsPark.vue?vue&type=script&lang=js"
import style0 from "./logisticsPark.vue?vue&type=style&index=0&id=6033228d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6033228d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6033228d')) {
      api.createRecord('6033228d', component.options)
    } else {
      api.reload('6033228d', component.options)
    }
    module.hot.accept("./logisticsPark.vue?vue&type=template&id=6033228d&scoped=true", function () {
      api.rerender('6033228d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/softBusinessLogistics/logisticsPark.vue"
export default component.exports